import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "../contexts/analytics/hooks";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import { useSnackbar } from "../contexts/SnackbarContext";
import { backendService } from "../services/backend.service";
import type { ExternalSource, HrisIntegrationType } from "../utils/models";
import { useErrorSnackbar } from "./useErrorSnackbar";

export const useResyncIntegration = () => {
	const { chosenDepartment } = useChosenDepartment();
	const showErrorSnackbar = useErrorSnackbar();
	const { showSnackbar } = useSnackbar();
	const { track } = useAnalytics();
	const { t } = useTranslation();

	return useMutation({
		mutationFn: async ({ source, type, folder, file }: { source: ExternalSource; type: HrisIntegrationType; folder?: string; file?: string }) => {
			if (!chosenDepartment?.department_id) return;
			const response = await backendService.resyncIntegration({ departmentId: chosenDepartment.department_id, source, type, folder, file });
			return response.data;
		},
		onSuccess: (data, variables) => {
			if (!data) return;
			const messageKey = data.task_names.length > 0 ? "integration.resync.scheduled" : "integration.resync.already.running";
			showSnackbar(t(messageKey), "success");
			track("Integrations - resync scheduled", {
				source: variables.source,
				type: variables.type,
				bumped_count: data.task_names.length,
				already_running_count: data.already_running_task_names.length,
				bumped_tasks: data.task_names.join(","),
				already_running_tasks: data.already_running_task_names.join(","),
			});
		},
		onError: (error) => showErrorSnackbar(t("integration.resync.failed"), { action: "hris_resync" }, error),
	});
};
